import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const ArrowReplyIcon = ({
  height = normalize(16),
  width = normalize(16),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 16 16"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.275 3.09036C10.5036 2.86181 10.8741 2.86181 11.1027 3.09036L14.3688 6.35647C14.5974 6.58502 14.5974 6.95557 14.3688 7.18412L11.1027 10.4502C10.8741 10.6788 10.5036 10.6788 10.275 10.4502C10.0465 10.2217 10.0465 9.85114 10.275 9.62259L13.1273 6.7703L10.275 3.918C10.0465 3.68945 10.0465 3.3189 10.275 3.09036Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.11695 7.35552C5.57918 7.35552 5.06344 7.56915 4.68317 7.94941C4.30291 8.32967 4.08929 8.84541 4.08929 9.38318V13.9557C4.08929 14.279 3.82727 14.541 3.50405 14.541C3.18084 14.541 2.91882 14.279 2.91882 13.9557V9.38318C2.91882 8.53499 3.25577 7.72153 3.85553 7.12177C4.4553 6.522 5.26875 6.18506 6.11695 6.18506H13.9556C14.2788 6.18506 14.5409 6.44708 14.5409 6.77029C14.5409 7.0935 14.2788 7.35552 13.9556 7.35552H6.11695Z"
      fill={color}
    />
  </Svg>
);

export default ArrowReplyIcon;
